import createIcon from '../../createIcon';

/**
 * @component @name LinkOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgN0gxM1Y4LjlIMTdDMTguNzEgOC45IDIwLjEgMTAuMjkgMjAuMSAxMkMyMC4xIDEzLjQzIDE5LjEyIDE0LjYzIDE3Ljc5IDE0Ljk4TDE5LjI1IDE2LjQ0QzIwLjg4IDE1LjYxIDIyIDEzLjk1IDIyIDEyQzIyIDkuMjQgMTkuNzYgNyAxNyA3Wk0xNiAxMUgxMy44MUwxNS44MSAxM0gxNlYxMVpNMiA0LjI3TDUuMTEgNy4zOEMzLjI5IDguMTIgMiA5LjkxIDIgMTJDMiAxNC43NiA0LjI0IDE3IDcgMTdIMTFWMTUuMUg3QzUuMjkgMTUuMSAzLjkgMTMuNzEgMy45IDEyQzMuOSAxMC40MSA1LjExIDkuMSA2LjY2IDguOTNMOC43MyAxMUg4VjEzSDEwLjczTDEzIDE1LjI3VjE3SDE0LjczTDE4Ljc0IDIxTDIwIDE5Ljc0TDMuMjcgM0wyIDQuMjdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LinkOff = createIcon('LinkOff', [
  [
    'path',
    {
      d: 'M17 7H13V8.9H17C18.71 8.9 20.1 10.29 20.1 12C20.1 13.43 19.12 14.63 17.79 14.98L19.25 16.44C20.88 15.61 22 13.95 22 12C22 9.24 19.76 7 17 7ZM16 11H13.81L15.81 13H16V11ZM2 4.27L5.11 7.38C3.29 8.12 2 9.91 2 12C2 14.76 4.24 17 7 17H11V15.1H7C5.29 15.1 3.9 13.71 3.9 12C3.9 10.41 5.11 9.1 6.66 8.93L8.73 11H8V13H10.73L13 15.27V17H14.73L18.74 21L20 19.74L3.27 3L2 4.27Z',
      key: 'urycq5',
    },
  ],
]);

export default LinkOff;
